import { appApi } from './app_api';

export const customerEventsApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getPastEvents: builder.query({
      query: ({ customerId, leagueEvents = false }) => `/customers/${customerId}/events/past_for_customer?league_events=${leagueEvents}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, { customerId }) => [{ type: 'Events', id: customerId }],
    }),
    getUpcomingEvents: builder.query({
      query: ({ customerId, leagueEvents = false }) => `/customers/${customerId}/events/upcoming_for_customer?league_events=${leagueEvents}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, { customerId }) => [{ type: 'Events', id: customerId }],
    }),
    getArchivedEvents: builder.query({
      query: ({ customerId, leagueEvents = false }) => `/customers/${customerId}/events/archived?league_events=${leagueEvents}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, { customerId }) => [{ type: 'Events', id: customerId }],
    }),
    getPossibleEventTypes: builder.query({
      query: ({ customerId, isLeague }) => `/customers/${customerId}/event_types?is_league=${isLeague}`,
      transformResponse: (response) => response.data,
    }),
    getEventTypes: builder.query({
      query: ({ customerId, isLeague }) => `/customers/${customerId}/event_types?is_league=${isLeague}`,
      providesTags: (result, error, { customerId }) =>
        [...(result ?? []).map(({ id }) => ({ type: 'EventTypes', id })), { type: 'EventTypes', id: customerId }],
      transformResponse: (response) => response.data,
    }),
    addEvent: builder.mutation({
      query: ({ customerId, event }) => ({
        url: `/customers/${customerId}/events`,
        method: 'POST',
        body: event,
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Events', id: customerId }],
    }),
    editEvent: builder.mutation({
      query: ({ customerId, eventId, event }) => ({
        url: `/events/${eventId}`,
        method: 'PUT',
        body: event,
      }),
      invalidatesTags: (result, error, { customerId, eventId }) => [{ type: 'Events', id: customerId }, { type: 'Event', id: eventId }],
    }),
    archiveEvent: builder.mutation({
      query: ({ customerId, eventId }) => ({
        url: `/customers/${customerId}/events/${eventId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Events', id: customerId }],
    }),
    restoreEvent: builder.mutation({
      query: ({ customerId, eventId }) => ({
        url: `/customers/${customerId}/events/${eventId}/restore`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Events', id: customerId }],
    }),
    createEventType: builder.mutation({
      query: ({ customerId, name }) => ({
        url: `/customers/${customerId}/event_types`,
        method: 'POST',
        body: { name },
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'EventTypes', id: customerId }],
    }),
  }),
});

export const {
  useGetPastEventsQuery,
  useGetUpcomingEventsQuery,
  useLazyGetArchivedEventsQuery,
  useGetPossibleEventTypesQuery,
  useGetEventTypesQuery,
  useAddEventMutation,
  useEditEventMutation,
  useArchiveEventMutation,
  useRestoreEventMutation,
  useCreateEventTypeMutation,
} = customerEventsApi;
